// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"group-text__visuallyhidden--LRQcQ","focusable":"group-text__focusable--rh3Nj","text":"group-text__text--Mtf7M"};